__turbopack_context__.v({
  "className": "saans_f8486ea3-module__vqAuSW__className",
  "variable": "saans_f8486ea3-module__vqAuSW__variable",
});
